import { createAction, props } from '@ngrx/store';
import {
  AdminDomain,
  AdminDomainDetail,
  AdminDomainsListMeta,
  UpdateDomainSettingsPayload,
} from '../models/admin-domain.model';
import { ApiTableFilter } from '../../../shared/models/table-filter.model';

export const loadAdminDomains = createAction(
  '[Admin Domains] Load Admin Domains',
  props<{
    page?: number;
    perPage?: number;
    search?: string;
    filters?: ApiTableFilter[];
    filterLink?: string;
  }>(),
);

export const loadAdminDomainsSuccess = createAction(
  '[Admin Domains] Load Admin Domains Success',
  props<{ domains: AdminDomain[]; meta: AdminDomainsListMeta }>(),
);

export const loadAdminDomainsFailure = createAction(
  '[Admin Domains] Load Admin Domains Failure',
  props<{ error: string }>(),
);

export const loadAdminDomainDetail = createAction(
  '[Admin Domains] Load Admin Domain Detail',
  props<{ domainUuid: string }>(),
);

export const loadAdminDomainDetailSuccess = createAction(
  '[Admin Domains] Load Admin Domain Detail Success',
  props<{ domain: AdminDomainDetail }>(),
);

export const loadAdminDomainDetailFailure = createAction(
  '[Admin Domains] Load Admin Domain Detail Failure',
  props<{ error: string }>(),
);

export const updateDomainSettings = createAction(
  '[Admin Domains] Update Domain Settings',
  props<{ domainUuid: string; payload: UpdateDomainSettingsPayload }>(),
);

export const updateDomainSettingsSuccess = createAction(
  '[Admin Domains] Update Domain Settings Success',
);

export const updateDomainSettingsFailure = createAction(
  '[Admin Domains] Update Domain Settings Failure',
  props<{ error: string }>(),
);

export const clearSelectedAdminDomain = createAction(
  '[Admin Domains] Clear Selected Admin Domain',
);

export const resetAdminDomainsState = createAction('[Admin Domains] Reset State');
